import { useSyncExternalStore } from "react";
import type { Attachment } from "@/lib/types";

/**
 * Store EXTERNE minimal pour l'éditeur de retouche d'image (`ImageStudio`) dans
 * le CMS avancé (Puck).
 *
 * Même raison d'être que `media-picker-store` : l'éditeur ne peut PAS vivre dans
 * le rendu d'un champ Puck (ouvrir une modale / cliquer dedans peut désélec-
 * tionner le bloc → Puck démonte le panneau de champs → la modale disparaîtrait).
 * On déporte donc l'éditeur dans un HOST monté UNE fois hors du panneau
 * (cf. `PuckImageStudioHost`, branché via `overrides.puck`). Le champ ne fait
 * qu'OUVRIR l'éditeur via ce store, en lui passant l'`Attachment` à retoucher.
 *
 * La retouche régénère les dérivés S3 SUR PLACE (même `link`, même id
 * d'attachment) : rien n'est réécrit sur le bloc Puck — le host se contente
 * d'invalider les queries d'attachment pour rafraîchir l'aperçu.
 */
type ImageStudioState = {
  open: boolean;
  attachment: Attachment | null;
};

let state: ImageStudioState = { open: false, attachment: null };
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function openImageStudio(attachment: Attachment): void {
  state = { open: true, attachment };
  emit();
}

export function closeImageStudio(): void {
  state = { ...state, open: false };
  emit();
}

export function useImageStudioState(): ImageStudioState {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => state,
  );
}
